import React, { useContext, useMemo } from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import { useLocation, useNavigate } from "react-router-dom";
import { NoodleModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { isHttpOK } from "nood-comp/src/net/xhr";
import { queryStringModifier } from "nood-comp/src/util/converters/converters";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import EventCategories from "src/routes/event/categories/EventCategories";
import EventCategoryEditor from "src/routes/event/categories/EventCategoryEditor";
import EventCategoryView from "src/routes/event/categories/EventCategoryView";
export default function EventCategoriesIndex(props) {
  var _useLocation;
  var id = useURLParam('id');
  var modalCtx = useContext(NoodleModalContext);
  var navigate = useNavigate();
  var queryString = (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.search;
  var items = useMemo(function () {
    return [{
      id: 'list',
      label: 'Categories',
      icon: 'list',
      content: /*#__PURE__*/React.createElement(EventCategories, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'add',
      label: 'Add',
      icon: 'plus',
      content: /*#__PURE__*/React.createElement(EventCategoryEditor, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'view',
      label: 'View',
      icon: 'eye',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(EventCategoryView, null),
      queryString: {
        id: id
      }
    }, {
      id: 'edit',
      label: 'Edit',
      icon: 'edit-2',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(EventCategoryEditor, null),
      queryString: {
        id: id
      }
    }, {
      id: 'delete',
      label: 'Delete',
      icon: 'x',
      show: id !== null,
      __click: function __click(e) {
        modalCtx.__confirmDelete({
          entity: "Event Category",
          endpoint: "/event-category/".concat(id),
          __onAfterDelete: function __onAfterDelete(response) {
            if (isHttpOK(response)) {
              navigate(queryStringModifier({
                queryString: queryString,
                modifiers: {
                  "do": "list",
                  id: undefined
                }
              }));
            }
          }
        });
      }
    }];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Event Categories",
    icon: "grid"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: items
  }));
}

// @ts-ignore